import { getUser } from "../../utils/auth";

export default function AccountsDashboard() {
  const user = getUser();

  return (
    <div>
      <h1 className="text-2xl font-bold">Accounts Dashboard</h1>
      <p className="mt-2">Welcome, <strong>{user?.name}</strong></p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <div className="bg-white p-4 rounded shadow text-center">Total Revenue: ₹12,50,000</div>
        <div className="bg-white p-4 rounded shadow text-center">Pending Invoices: 14</div>
      </div>
    </div>
  );
}